import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import { PlayerGetter, PlayerState } from "@/components/player/types";

export const getters: GetterTree<PlayerState, RootState> &
  Record<PlayerGetter, Getter<PlayerState, RootState>> = {
  [PlayerGetter.GetPause](state) {
    return state.pause;
  }
};
